import { render, staticRenderFns } from "./AddToGroupNewModal.vue?vue&type=template&id=6e9f3763&scoped=true"
import script from "./AddToGroupNewModal.vue?vue&type=script&lang=js"
export * from "./AddToGroupNewModal.vue?vue&type=script&lang=js"
import style0 from "./AddToGroupNewModal.vue?vue&type=style&index=0&id=6e9f3763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f3763",
  null
  
)

export default component.exports